import { ActionFooterWithMenu } from '../shared/ActionFooterWithMenu';

interface RefinementFooterProps {
    isSubmitting: boolean;
    onProceed: () => void;
    onReject: () => void;
    onEndTreatment: () => void;
}

export function RefinementFooter({
    isSubmitting,
    onProceed,
    onReject,
    onEndTreatment
}: RefinementFooterProps) {
    return (
        <ActionFooterWithMenu
            primaryLabel="Proceed with refinement →"
            canSubmit={true}
            isSubmitting={isSubmitting}
            onSubmit={onProceed}
            menuActions={[
                { label: 'Reject refinement', onClick: onReject, tone: 'amber' },
                { label: 'End treatment', onClick: onEndTreatment, tone: 'red' }
            ]}
        />
    );
}
